import styles from "./Header.module.css";
import logo from "../../images/svg/logo.svg";
import logoMobile from "../../images/svg/logo_text.svg";
import { useEffect } from "react";
import { ReactComponent as BurgerIcon } from "../../images/svg/burger.svg";
import { ReactComponent as TelegramIcon } from "../../images/svg/telegram_icon.svg";
import { ReactComponent as WhatsappIcon } from "../../images/svg/whatsapp_icon.svg";
import { ReactComponent as TelephoneIcon } from "../../images/svg/telephone.svg";
import { useModal } from "../../hooks/useModalHook";
import { useMediaQuery } from "react-responsive";
import { Link, useLocation } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll";
import React, { memo } from "react";

const scrollToSection = (section) => (e) => {
  e.preventDefault();
  if (section === "top") {
    window.scrollTo({ top: 0, behavior: "smooth" });
    return;
  }
  if (section) {
    const el = document.getElementById(section);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  }
};

const Header = ({ navItems, showClone }) => {
  const { openModal, modal, closeModal } = useModal();
  const location = useLocation();
  const isRoot = ["/", "/b", "/c"].includes(location.pathname);

  useEffect(() => {
    if (modal.open) {
      closeModal();
    }
    // eslint-disable-next-line
  }, [location.pathname]);

  useEffect(() => {
    const scrollToTop = document.getElementById("scrollToTop");
    if (scrollToTop) scrollToTop.style.display = "block";
  }, []);

  const isDesktop = useMediaQuery({ query: "(min-width: 1281px)" });
  const shouldShowNav = isDesktop;
  if(showClone) return null;
  return (
    <header className={`${styles.header} ${modal.open ? styles.header_hidden : ''}`}>
      <div className={styles.header_left_wrapper}>

        <button
          className={`${styles.burger} ${styles.burgerButton}`}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            openModal("burger")
          }}
        >
          <BurgerIcon aria-label="Открыть меню" width={60} height={40} className={styles.burgerIcon} />
        </button>

        <Link to="/" className={styles.logo_link}>
          <picture>
            <source media="(max-width: 1060px)" srcSet={logoMobile} />
            <source media="(min-width: 769px)" srcSet={logo} />
            <img
              className={styles.logo}
              src={logo}
              alt="Логотип AltraVita"
              decoding="async"
            />
          </picture>
        </Link>


        <nav className={`${styles.nav} ${shouldShowNav ? styles.visible : ""}`}>
          <ul className={styles.nav_menu}>
            {!isRoot ? (
              <li className={styles.nav_menu_item}>
                <Link to="/" className={styles.nav_menu_link}>
                  Вернуться на главную
                </Link>
              </li>
            ) : (
              navItems.map((item, index) => {
                if(item.section === "gallery") return;
                 return (
                  <li className={styles.nav_menu_item} key={index}>
                    {item.section && item.section !== "top" ? (
                      <ScrollLink
                        to={item.section}
                        smooth={true}
                        offset={-80}
                        duration={500}
                        className={styles.nav_menu_link}
                        activeClass={styles.nav_menu_link__active}
                        spy={true}
                        tabIndex={0}
                        href={item.href}
                      >
                        {item.text}
                      </ScrollLink>
                    ) : (
                      <a
                        className={`${styles.nav_menu_link}`}
                        onClick={item.section === "top" ? scrollToSection(item.section) : undefined}
                        tabIndex={0}
                        href={item.href}
                      >
                        {item.text}
                      </a>
                    )}
                  </li>
                )
              })
            )}
          </ul>
        </nav>

      </div>



      <div className={styles.header_button_wrapper}>
        <a
          target="_blank"
          rel="noreferrer"
          href="https://t.me/AltravitaEKObot"
          className={`${styles.button_support} ${styles.support_consultant} light_sweep`}
        >
          <span className={styles.button_span}>Поддержка</span>
          <TelegramIcon className={styles.telegram_icon} aria-label="Telegram" />
        </a>
        <a
          target="_blank"
          rel="noreferrer"
          href="https://wa.me/+79257364438"
          className={`${styles.button_support} ${styles.support_whatsapp}`}
        >
          <WhatsappIcon className={styles.whatsapp_icon} aria-label="WhatsApp" />
        </a>

        <a className={styles.telephone} href="tel:+74992260316">
          {isDesktop ? (
            "+7 499 226 03 16"
          ) : (
            <TelephoneIcon aria-label="Телефон" />
          )}
        </a>
        <a
          target="_blank"
          rel="noreferrer"
          className={styles.address}
          href="https://yandex.ru/maps/-/CHbaIR75"
          aria-label="Адрес: г. Москва, ул. Нагорная 4а"
        >
          <p className={styles.address_paragraph}>г. Москва,</p>
          <p className={styles.address_paragraph}>ул. Нагорная 4а</p>
        </a>
      </div>
    </header>
  );
};

export default memo(Header);
